import { Text } from '@common-fe/common-fe';
import styled from 'styled-components';

export const StyledTitle = styled(Text)`
  border-bottom: 1px dotted ${({ theme }) => theme.colors.border};
`;
